import React from "../../__compat__/react/main.entry.mjs.mjs";
import { OfferIcon } from "./OfferIcon.mjs.mjs";
import { StyledOfferTag, StyledLabel, StyledButton, StyledTextContainer, StyledOfferTagIcon, } from "./OfferTag.styles.mjs.mjs";
const getIconSize = (size) => (size === 'large' ? 'small' : 'xs');
/**
 * @experimental
 */
export const OfferTag = React.forwardRef(({ standalone = false, size = 'large', 'data-testid': dataTestId, ariaLabel, button, label, }, ref) => {
    const renderButton = () => {
        if (button) {
            const { ariaLabel: buttonAriaLabel, handleClick } = button;
            const iconSize = getIconSize(size);
            return (React.createElement(StyledButton, { onClick: handleClick, "aria-label": buttonAriaLabel },
                React.createElement(StyledOfferTagIcon, { size: iconSize, name: "info-circle" })));
        }
        return null;
    };
    return (React.createElement(React.Fragment, null, standalone ? (React.createElement(OfferIcon, { ref: ref, "aria-label": ariaLabel, "data-testid": dataTestId })) : (React.createElement(StyledOfferTag, { size: size, ref: ref, "data-testid": dataTestId, "aria-label": ariaLabel },
        React.createElement(StyledTextContainer, { size: size },
            React.createElement(OfferIcon, { size: size, "aria-hidden": true }),
            React.createElement(StyledLabel, { size: size }, label)),
        renderButton()))));
});
OfferTag.displayName = 'OfferTag';
//# sourceMappingURL=OfferTag.mjs.mjs.map